export const documents = {
  policy: '/pdf/visitors/policy-wording.pdf',
}
